module.exports = __webpack_public_path__ + "static/LOGO 3-428f68c7d15a824db7aee748e21a923a.png";